export const SPACES_SCREENS = {
	MENU: 0,
	CAMPAIGNS: 1,
	FAVORITES: 2,
	CAMPAIGN_CONTRACTS: 3,
	SPACES_BROWSING: 4
}
